import React from "react";
import AnnunciFunebri from "../shared/AnnunciFunebri";

/**
 * Global view of all Annunci Funebri across all organizations
 */
const GiottoAnnunciFunebri = () => {
  return (
    <AnnunciFunebri 
      orgId={null}
      showBreadcrumb={true}
      showTitle={true}
    />
  );
};

export default GiottoAnnunciFunebri;
